import { format } from 'date-fns';

import locales from 'src/constants/locales';

const formatByLang = {
    fr: 'dd/MM/yyyy',
    en: 'MM/dd/yyyy',
};

/**
 * Format date dd/MM/yyy, ex: 18/01/2021
 */
const formatDateToIso = (date: string, lang: SupportedLangs) =>
    format(new Date(date), formatByLang[lang], {
        locale: locales[lang],
    });

export default formatDateToIso;
